import { createTheme } from '@mui/material';
import { MODERN_COLORS } from './Application/Components/ModernLayout/tokens';

export const appTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: MODERN_COLORS.primary,
      light: MODERN_COLORS.primaryLight,
      dark: MODERN_COLORS.primaryDark,
    },
    secondary: {
      main: MODERN_COLORS.primary,
      light: MODERN_COLORS.primaryLight,
      dark: MODERN_COLORS.primaryDark,
    },
    error: {
      main: MODERN_COLORS.errorText,
    },
    success: {
      main: MODERN_COLORS.successText,
    },
    warning: {
      main: MODERN_COLORS.warningText,
    },
    background: {
      default: '#f8fafc',
    },
  },
  shape: {
    borderRadius: 8,
  },
  typography: {
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        rounded: {
          borderRadius: 12,
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: '#f8fafc',
          '& .MuiTableCell-head': {
            fontWeight: 700,
            color: MODERN_COLORS.primaryDark,
            textTransform: 'uppercase',
            letterSpacing: '0.04em',
            fontSize: '0.72rem',
          },
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        hover: {
          '&:hover': {
            backgroundColor: `${MODERN_COLORS.bgLight} !important`,
          },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 12,
          border: `1.5px solid ${MODERN_COLORS.borderCyan}`,
        },
      },
    },
  },
});

export default appTheme;
